.RTRADContainer
    width: 100%
    color: rgb($globalSettingsFontPrimary)
    display: flex
    flex-direction: column
    overflow-x: hidden
    overflow-y: auto
    padding: 20px
    box-sizing: border-box

    .RTRADArticle
        width: 100%
        display: flex
        flex-direction: row
        justify-content: space-between
        align-items: center
        gap: 10px

        .RTRADInfo
            min-width: 0
            display: flex
            flex-direction: row
            justify-content: space-between
            gap: 10px

            .RTRADDescription
                min-width: 0
                height: 100%
                display: flex
                flex-direction: column
                overflow: hidden

                .RTRADDescriptionTitle
                    font-weight: 700

                .RTRADDescriptionText
                    overflow: hidden
                    white-space: nowrap
                    text-overflow: ellipsis

            .RTRADImage
                width: 40px
                height: 40px
                border-radius: $globalSettingsRoundingSmall
                overflow: hidden
                flex-shrink: 0

                img
                    width: 100%
                    height: 100%

        .RTRADSubItem
            font-weight: 700

        .RTRADPrice
            display: flex
            flex-direction: column
            align-items: flex-end
            gap: 5px
            flex-shrink: 0
        .RTRADPriceInline
            display: inline
            white-space: nowrap
            overflow: hidden
        .RTRADPriceDeposit
            color: rgb($globalSettingsFontSecondary)
        .RTRADMileage
            text-decoration: underline
            cursor: pointer

    .RTRADMinorArticle
        padding-left: 10px
